class Scroller{
    constructor(){
        this.reveals = document.querySelectorAll('.reveal')
        this.revealsImage = document.querySelectorAll('.reveal-image')
        this.wrmHeader = document.querySelector('.main-header')
        this.showreel = document.querySelector('.showreel_wrapper')
        this.events()
    }

    events(){
        window.addEventListener('scroll', ()=> {
            this.reveal()
            this.revealImages()
            this.homeNavToggle()
            if(this.showreel){
                this.focusShowreel()
            }
        })
        document.body.addEventListener('touchmove', ()=> {
            this.reveal()
            this.revealImages()
            if(this.showreel){
              this.focusShowreel()
            }
        })
        
    }

    homeNavToggle(){
        this.scrollPosition = window.scrollY
        if( this.scrollPosition >= 15){
          let opacity = 1 - (this.scrollPosition / 200)
          this.wrmHeader.style.opacity = opacity
            //this.navBar.classList.add('minimize')
        }
        if(this.scrollPosition < 15){
          this.wrmHeader.style.opacity = 1
        }
    }
    
    reveal(){
        for (let i = 0; i < this.reveals.length; i++) {
          let windowHeight = window.innerHeight
          let elementTop = this.reveals[i].getBoundingClientRect().top
          let elementVisible = 200
          if (elementTop < windowHeight - elementVisible) {
            this.reveals[i].classList.add("show")
            this.currentElement = i
          } else {
            this.reveals[i].classList.remove("show")
          }
        }
    }
    focusShowreel(){
      let windowHeight = window.innerHeight
      let elementTop = this.showreel.getBoundingClientRect().top
      let elementVisible = 0
      let val = Math.abs(elementTop/100)
      // if (elementTop < windowHeight - elementVisible && val > 0) {
      //   this.showreel.style = '--size:'+ val +'%'
      //   console.log(val)
      // }
      if (elementTop > 0) {
        this.showreel.style = '--size:'+ val +'%'
      }else{
        this.showreel.style = '--size:0%'
        this.showreel.style.display = 'flex'
      }
    }
    revealImages(){
        for (let i = 0; i < this.revealsImage.length; i++) {
          let windowHeight = window.innerHeight
          let elementTop = this.revealsImage[i].getBoundingClientRect().top
          let elementVisible = 300
      
          if (elementTop < windowHeight - elementVisible) {
            this.revealsImage[i].src = this.revealsImage[i].getAttribute('data-image')
            this.revealsImage[i].style.opacity = 1
            this.revealsImage[i].style.transform = 'translateY(0px)'
            this.currentElement = i
          }
        }
    }
} 

export default Scroller